// Package Imports
import axios from "axios";
import { toJS } from "mobx";

// Project Imports
import * as APITypes from "constants/API";
import AuthStore from "../../login/store/AuthStore";
import OptimizationStore from "../store/OptimizationStore";
import updateProductwiseRiskData from "./updateProductwiseRiskData";
import { API_DELAY_TIME } from "constants/Constants";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants";

const generateGetRecoApiRequest = () => {
  let productDetails = toJS(OptimizationStore.product_list_data);
  const journeyId = getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID);

  let requestList = [];
  productDetails.forEach((item) => {
    item.data.forEach((dataItem) => {
      if (Array.isArray(dataItem.BI)) {
        dataItem.BI.forEach((biData) => {
          requestList.push({
            journey_id: journeyId,
            family_product_id: dataItem.family_product_id,
            risk_type: biData.risk,
          });
        });
      } else {
        requestList.push({
          journey_id: journeyId,
          family_product_id: dataItem.family_product_id,
          risk_type: "high",
        });
      }
    });
  });


  


  const promises = [];
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  async function makeRequests() {
    for (const item of requestList) {
      promises.push(axios.post(APITypes.GET_RECOMMENDATION_RISK_DETAILS, item));
      await delay(API_DELAY_TIME);
    }

    await Promise.all(promises.map((item) =>
      item.then((result) => updateProductwiseRiskData(result))
    ));
  }

  makeRequests()
    .then(() => {
      console.log("All requests completed");
    })
    .catch((error) => {
      console.error("Error making requests: ", error);
    });
}

export default generateGetRecoApiRequest